(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.components:mxUiAccessibility
	 * @module mx.components
	 * @restrict 'A'
	 * @description
	 * The mx-ui-accessibility directive is used to set read-only or disabled attribute for some container in mx-form.
	 *
	 * The example below demonstrates some of the attributes you may use with the mxUiAccessibility control:
	 * @param {boolean} disabled= - The disabled property sets whether all controls of container with mx-ui-accessibility should be disabled, or not.
	 * @param {boolean} readOnly= - The readOnly property sets whether all controls of container with mx-ui-accessibility should be read-only.
	 *
	 * @usage <mx-some-direcitve-container mx-ui-accessibility read-only="true" disabled="true"></mx-some-direcitve-container>
	 */

	angular.module('mx.components').directive('mxUiAccessibility', function mxUiAccessibilityDirective() {
		return {
			restrict: 'A',
			require: ['mxUiAccessibility'],
			link: function (scope, element, attrs, ctrls) {
				var vm = ctrls[0];

				Object.defineProperty(vm, 'readOnly', {
					get: function () {
						return attrs.readOnly === 'true';
					},
				});

				Object.defineProperty(vm, 'disabled', {
					get: function () {
						return attrs.disabled === 'true';
					},
				});
			},
			template: '',
			controller: function () {},
		};
	});
})();
